module.exports = {
	"apertureWidth": "Larghezza apertura",
	"apertureLength": "Lunghezza apertura",
	"apertureGap1": "Apertura 1",
	"apertureGap2": "Apertura 2",
	"ballDiameter": "Diametro sfera",
	"bodyOffset": "Offset corpo",
	"bodyLength": "Lunghezza corpo",
	"bodyDiameter": "Diametro corpo",
	"bodyHeight": "Altezza corpo",
	"bodyColor": "Colore corpo",
	"componentFamily": "Famiglia componenti",
	"colPitch": "Passo col.",
	"chipArrayNote": "* L1 e b1 sono facoltativi.",
	"crystalNote": "* Selezionare una quota facoltativa (D, D2, L). Combinazioni diverse possono produrre differenti dimensioni per il perimetro del layout componente.",	
	"densityLevel": "Livello densità",	
	"femaleStandoffNote": "* Il riempimento del foro di montaggio è facoltativo e può essere generato immettendo i valori per le quote mostrate nell'immagine a sinistra. Il diametro del foro (b) viene utilizzato per la generazione dei fori di montaggio e per il modello meccanico di distanziale senza filettatura interna.",
	"footprintOrigin": "Origine layout componente",
	"hPinPitch": "Passo piedino orizzontale",
	"hTerminalGap": "Spazio terminale orizzontale",
	"hTerminalTailLength": "Lunghezza coda terminale orizzontale",
	"innerThreadDepth": "Profondità filettatura interna",
	"innerThreadSize": "Dimensione filettatura interna",
	"innerThreadDesignation": "Designazione filettatura interna",
	"leadDiameter": "Diametro capocorda",
	"leadSpan": "Estensione capocorda",
	"leadSpan1": "Estensione capocorda 1",
	"leadSpan2": "Estensione capocorda 2",
	"leadShape": "Forma capocorda",
	"largerTerminalLength": "Lunghezza terminale più grande",
	"largerTerminalWidth": "Larghezza terminale più grande",
	"maleFemaleStandoffNote": "* Il riempimento del foro di montaggio è facoltativo e può essere generato immettendo i valori per le quote mostrate nell'immagine a sinistra. Il diametro del foro (b) viene utilizzato per la generazione dei fori di montaggio.",
	"mapSilkscreen": "Mappa serigrafia a corpo",
	"optionalDimensionNote": "* Selezionare una quota facoltativa (D, D2, L). Combinazioni diverse possono produrre differenti dimensioni per il perimetro del layout componente.",
	"oddTerminalLength": "Lunghezza terminale sciolto",
	"oddTerminalWidth": "Larghezza terminale sciolto",
	"optionalDimension": "Quota facoltativa",	
	"partialThread": "Filettatura parziale",	
	"pasteCoverage": "Copertura in flussante",
	"producibilityLevel": "Livello di producibilità",
	"pinPitch": "Passo piedino",
	"padToHoleRatio": "Rapporto da riempimento a foro",
	"padRoundness": "Rotondità riempimento",
	"pinNumbering": "Numerazione piedini",
	"postLength": "Lunghezza attacco",
	"postThreadSize": "Dimensioni filettatura attacco",
	"postThreadDesignation": "Designazione filettatura attacco",
	"rowPitch": "Passo riga",
	"tabWidth": "Larghezza scheda",
	"tabLength": "Lunghezza scheda",
	"terminalThickness": "Spessore terminale",
	"terminalWidth": "Larghezza terminale",
	"terminalLength": "Lunghezza terminale",
	"terminalGap": "Spazio terminale",
	"terminalCCGap": "Centro terminale-spazio centrale",
	"terminalCCGap1": "Centro terminale-spazio centrale 1",
	"terminalCCGap2": "Centro terminale-spazio centrale 2",
	"terminalTailLength": "Lunghezza coda terminale",
	"terminalPostLength": "Lunghezza attacco terminale",
	"terminalType": "Tipo terminale",	
	"threadDepth": "Profondità filettatura",
	"threadSize": "Dimensioni filettatura",
	"threadDesignation": "Designazione filettatura",	
	"threaded": "Filettato",
	"truncateMiddlePin": "Tronca piedino centrale",		
	"vPinPitch": "Passo piedino verticale",
	"vTerminalGap": "Spazio terminale verticale",
	"vTerminalTailLength": "Lunghezza coda terminale verticale",
	"#Rows": "N. righe",
	"#Cols": "N. col",
	"#Pins": "N. piedini",
	"#DPins": "N. piedini (lato D)",
	"#EPins": "N. piedini (lato E)",
	"padShape": "Forma pad",
	"RESISTOR": "Resistore",
	"NONPOLARIZED_CAPACITOR": "Condensatore - Non polarizzato",
	"POLARIZED_CAPACITOR": "Condensatore polarizzato",
	"DIODE": "Diodo",
	"FUSE": "Fusibile",
	"INDUCTOR": "Induttore",
	"POLARIZED_INDUCTOR": "Induttore polarizzato",
	"NONPOLARIZED_INDUCTOR": "Induttore - Non polarizzato",
	"LRCCW": "In senso antiorario dal basso a sinistra",
	"LRCW": "Senso orario dall'alto a sinistra",
	"ZZBT": "Zig-zag dall'estremità inferiore sinistra",
	"PIN_ONE": "Piedino 1",
	"CENTER_PADS": "Centro dei riempimenti",
	"female": "Femmina",
	"male": "Maschio",
	"maleFemale": "Maschio-Femmina",
	"ROUND": "Rotondo",
	"HEX": "Esagonale",
	"SQUARE": "Quadrato",
	"Round": "Rotondo",
	"Square": "Quadrato",
	"RoundedSquare": "Quadrato arrotondato",
	"Rectangle": "Rettangolo",
	"Black": "Nero",
	"Green": "Verde",
	"Blue": "Blu",
	"Yellow": "Giallo",
	"Amber": "Ambra",
	"Brown": "Marrone",
	"Cyan": "Ciano",
	"Maroon": "Granata",
	"Grey": "Grigio",
	"Silver": "Argento",
	"Purple": "Viola",
	"Red": "Rosso",
	"White": "Bianco",
	"Most (A)": "Maggiore (A)",
	"Nominal (B)": "Nominale (B)",
	"Least (C)": "Minore (C)",
	"Most (M)": "Maggiore (M)",
	"Nominal (N)": "Nominale (N)",
	"Least (L)": "Minore (L)",
	"IC": "Circuito integrato (IC)",
	"PRECISION_INDUCTOR": "Induttore di precisione",
	"LED": "LED",
	"THERMISTOR": "Termistore",
	"POLARIZED_DIODE": "Diodo",
	"VARISTOR": "Varistore",
	"FERRITE_BEAD": "Nucleo di ferrite",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "PCP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Chip",
	"SOD": "SOD",
	"MOLDED_BODY": "Corpo stampato",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "Calotta elettronica",
	"CRYSTAL": "Cristallo",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Serie di chip, 2 lati piatto/concavo",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Serie di chip, 2 lati piatto/concavo",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Serie di chip, 2 lati convesso",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Angolo oscillatore concavo",
	"OSCILLATOR_J_LEAD": "Oscillatore con capocorda a J",
	"OSCILLATOR_L_BEND": "Oscillatore a L",
	"SOJ": "SOJ",
	"AXIAL": "Assiale",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Connettore (maschio) diritto",
	"PIN_HEADER_RA": "Connettore (maschio) con angolo a destra",
	"RECEPTACLE_HEADER_STRAIGHT": "Connettore (femmina) dritto",
	"RECEPTACLE_HEADER_RA": "Connettore (femmina) con angolo a destra",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Generico radiale (circolare)",
	"RADIAL_LED": "LED radiale (circolare)",
	"CRYSTAL_HC49": "Cristallo (HC49)",
	"FEMALE_STANDOFF": "Distanziale femmina",
	"MALE_FEMALE_STANDOFF": "Distanziale maschio-femmina",
	"SNAP_LOCK": "Blocco a innesto",
	"Optional_D": "D (estensione capocorda)",
	"Optional_D2": "D2 (spazio terminale)",
	"Optional_L": "L (lunghezza terminale)",
	"CONCAVE": "Concavo",
	"FLAT": "Piatto",
	"Oblong": "Oblungo",
	"Collapsing_Ball": "Sfera comprimibile",
	"Non_Collapsing_Ball": "Sfera non comprimibile",
	"mountingHolePad": "Pad foro di montaggio",
	"withVias": "Con piazzole",
	"viasCount": "Conteggio piazzole",
	"viaDiameter": "Diametro piazzola",
	"viaOffset": "Offset piazzola da centro foro",
	"viaThermalRelief": "Dispersione termica piazzola",
	"radialLedNote": "* c non è applicabile per la forma di capocorda arrotondato.",
	"lockHeight": "Altezza blocco",
	"overrideLockDiameter": "Sostituisci diametro blocco",
	"lockDiameter": "Diametro blocco",
	"overridePitch": "Sostituisci passo piedino",
	"bodyWidth": "Larghezza corpo",
	"padWidth": "Larghezza riempimento",
	"plated": "Placcato",
	"ViaOffset": "Offset piazzola da centro foro",
	"holeDiameter": "Diametro foro",
	"snapLockNote1": "* Il diametro del blocco (E1) viene calcolato automaticamente in base al diametro del corpo (E) e al diametro del foro (b). Tuttavia, è possibile fornire un valore personalizzato sostituendo il diametro del blocco.",
	"snapLockNote2": "* Il diametro del foro (b) non deve essere uguale al diametro del corpo (E) e al diametro del blocco (E1)",
	"leadWidth": "Larghezza capocorda",
	"leadThickness": "Spessore capocorda",
	"boardThickness": "Spessore scheda",
	"error1": "Non implementato.",
	"fabricationTolerance": "Tolleranza di fabbricazione", 
	"placementTolerance": "Tolleranza di posizionamento",
	"CAPACITOR": "Condensatore - Non polarizzato",
	"CAPACITOR_NONPOLARIZED": "Condensatore - Non polarizzato",
	"CAPACITOR_NON_POLARIZED": "Condensatore - Non polarizzato",
	"FILTER": "Filtro", 
	"TRANSISTOR": "Transistore",
	"ecapNote": "* Selezionare una quota facoltativa (D, D2, L). Combinazioni diverse possono produrre differenti dimensioni per il perimetro del layout componente.",
	"maximum": "Massimo", 
	"nominal": "Nominale", 
	"minimum": "Minimo",
	"bodyShape": "Forma corpo",
	"customSolderPaste": "Flussante personalizzato",
	"thermalPad": "Pad termoconduttivo",
	"thermalPadLength": "Lunghezza pad termoconduttivo",
	"thermalPadWidth": "Larghezza pad termoconduttivo",
	"RoundedRectangle": "Rettangolo arrotondato",
	"extendedEdgeLength": "Lunghezza spigolo esteso",
	"Generator": "Generatoree",
	"axialNote": "* Il passo del piedino viene calcolato automaticamente in base alle dimensioni del corpo, del terminale e del livello di producibilità per rendere il layout componente conforme a IPC. Tuttavia, è possibile fornire un valore personalizzato sostituendo il passo del piedino per creare un layout componente non conforme a IPC.",
	"baseHeight": "Altezza base",
	"CHIP_LED": "LED chip",
	"updatePreview": "Aggiorna anteprima",
	"Custom": "Personalizzato",
	"ledColorNote": "* Immettere un valore esadecimale per il colore del corpo personalizzato.",
	"customBodyColor": "Colore corpo personalizzato",							
	"lensShape": "Forma lente",
	"domeDiameter": "Diametro cupola",
	"RECT_FLAT_TOP": "Rettangolo con parte superiore piatta",
	"RECT_DOMED_TOP": "Rettangolo con parte superiore a cupola",
	'customFootprint': 'Layout componente personalizzato',
	'customPadLength': 'Lunghezza riempimento personalizzata',
	'customPadWidth': 'Larghezza riempimento personalizzata',
	'customPadGap': 'Spazio da riempimento a riempimento personalizzato',
	'customOddPadWidth': 'Larghezza riempimento dispari personalizzata',
	'customOddPadLength': 'Lunghezza riempimento dispari personalizzata',
	'customPadDiameter': 'Diametro riempimento personalizzato',
	'customPadSpan1': 'Estensione riempimento personalizzato 1',
	'customPadSpan2' : 'Estensione riempimento personalizzato 2',
	'customPadPitch' : 'Passo riempimento personalizzato',
	'pinPitch1' : 'Passo piedino 1',
	'customPadGap1': 'Spazio da riempimento a riempimento personalizzato 1',
	'Optional_g': 'g (Spazio riempimento personalizzato)',
	'Optional_p': 'p (Passo riempimento personalizzato)',

	// JS Widgets
	"New_Library": "Nuova libreria",
	"Components": "Componenti",
	"Component": "Componente",
	"Symbols": "Simboli",
	"Symbol": "Simbolo",
	"Footprints": "Layout componenti",
	"Footprint": "Layout componente",
	"Packages": "Pacchetti",
	"Package": "Pacchetto",
	"No": "No",
	"Name": "Nome",
	"Pins": "Piedini",
	"Pads": "Riempimenti",
	"Description": "Descrizione",
	"Variants": "Varianti",
	"Type": "Tipo",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "URN Library.io",
	"Library_io_Version": "Versione Library.io",
	"Link": "Collegamento",
	"Rename": 'Rinomina',
	"Edit_Description": 'Modifica descrizione',
	"Duplicate": 'Duplica', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Crea nuovo modello 3D',
	"Attach_Copy_Existing_3D_Model": 'Allega copia del modello 3D esistente',
	"Edit": 'Modifica',
	"Delete": 'Elimina',
	"Remove_From": 'Rimuovi da',
	"Update_To_Latest": 'Aggiorna alla versione più recente',
	"Create_New_Symbol": 'Crea nuovo simbolo',
	"Create_New_Footprint": 'Crea nuovo layout componente',
	"Create_New_Component": 'Crea nuovo componente',
	"Create_New_Package": 'Crea nuovo pacchetto',
	"Delete_Package_Children_Warning": "Verranno eliminati anche i pacchetti utilizzati da questo layout componente.",
	"No_Search_Results": "Nessun risultato della ricerca",
	"No_Library_Loaded": "Libreria non caricata",
	"Library_Stored_Fusion_Hub": "Questa libreria è memorizzata in your Fusion Hub.",
	"Library_Linked_Managed_Library": "Questa libreria è collegata ad una libreria gestita Library.io.",
	"Library_Local_Changes": "Questa libreria contiene modifiche che non sono state inserite in Library.io. Per inserirle, passare alla barra degli strumenti 'Gestisci'.",
	"Library_Remote_Changes": "Questa libreria contiene nuovi aggiornamenti che possono essere estratti da Library.io. Per estrarli, passare alla barra degli strumenti 'Gestisci'.",
	"View_on_Library_io": "Visualizza su Library.io",
	"Used_In": "Utilizzato in",
	"No_Selection": "Nessuna selezione",

	"No_Footprints": "Nessun layout componenti",
	"No_Symbols": "Nessun simbolo",
	"No_Components": "Nessun componente",
	"No_Packages": "Nessun pacchetto",

	"Package_Loading_Message": "Attendere il salvataggio e il caricamento del pacchetto.",
	"Attributes": "Attributi",
	"View_Attributes": "Visualizza attributi",
	"Edit_Attributes": "Visualizza attributi",
	"Edit_Description": "Modifica descrizione",
	
	"Use_Placeholder": "Utilizza segnaposto",
	"Placeholder_Message": "Utilizzare una forma segnaposto quando al layout componente non è associato nessun modello 3D.",

	"Hub": "Hub",
	"New_Symbol": 'Nuovo simbolo',
	"New_Footprint": 'Nuovo layout componente',
	"New_Component": 'Nuovo componente',
	"New_Package": 'Nuovo pacchetto',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Aggiornamento del pacchetto Library.io disponibile. Fare clic con il pulsante destro del mouse e scegliere Aggiorna.",
	"Package_Behind_Fusion": "Aggiornamento del pacchetto Fusion disponibile. Fare clic con il pulsante destro del mouse e scegliere Aggiorna.",
	"Package_Behind_Both": "Aggiornamento del pacchetto disponibile. Fare clic con il pulsante destro del mouse e scegliere Aggiorna.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "È necessario aggiornare la libreria prima di poter estrarre le modifiche degli asset. Per aggiornare la libreria, utilizzare la barra degli strumenti Gestisci.",
}